/* eslint-disable react/prop-types */
import React, { memo } from 'react';
import { useSelector } from 'react-redux';

const DepartmentsContainerHeader = () => {
	const { dict } = useSelector((state) => state.app);

	return (
		<div className='table__header-container'>
			<div className='table__departments__item head'>
				<div className='table__departments__item--col head'>
					{dict.departments.list.name.toUpperCase()}
				</div>
				<div className='table__departments__item--col head'>
					{dict.departments.list.header.toUpperCase()}
				</div>
				<div className='table__departments__item--col head'>
					{dict.departments.list.footer.toUpperCase()}
				</div>
				<div className='table__departments__item--col head' />
			</div>
		</div>
	);
};

export default memo(DepartmentsContainerHeader);